export default ({ request }) => ({
  ecomEvgPackingSchemeListApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDelApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeEnableApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/enable',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDeactivateApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/deactivate',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeCopyApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/copy',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeSkuListApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeSkuOptionsApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/sku/options',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDescGroupSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/desc/group/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDescGroupListApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/desc/group/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDescGroupDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/desc/group/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDescGroupDetailSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/desc/group/detail/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDescGroupDetailListApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/desc/group/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDescGroupDetailDelApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/desc/group/detail/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgPackingSchemeDescGroupDetailUpdateSortOrderApi(data = {}) {
    return request({
      url: '/ecom/evg/packing/scheme/desc/group/detail/updateSortOrder',
      method: 'POST',
      data,
    })
  },
})
